export enum StatusColor {
    GREEN = 'green',
    BLACK = 'black'
}
